import styled from 'styled-components'

export const Wrapper = styled.div`
  .ant-form-item-row {
    flex-direction: column;
  }

  .ant-form-item-no-colon {
    display: flex;
    gap: 4px;
    font-weight: 600;
    font-size: 13px;
    color: black;
  }

  .ant-input {
    border-color: #d9d9d9;
  }

  /* 登録先 */
  .ant-select-outlined.ant-select-disabled:not(.ant-select-customize-input) {
     .ant-select-selector {
      color: #333;
     }
  }

  /* タイトル・メモ */
  .ant-input-outlined.ant-input-disabled,
  .ant-input-outlined[disabled] {
      color: #333;
  }

  /* 期日 */
  .ant-picker .ant-picker-input > input[disabled] {
    color: #333;
  }

  .target-achievement {
    display: grid;
    grid-template-columns: 1fr 3rem 1fr;
    gap: 4px;
    width: 50%;
  }

  .form-action-group {
    display: flex;
    justify-content: center;
    gap: 0.25rem;
    margin: 2rem 0;

    .btn-post {
      background: ${({ theme }) => theme.talk_primary};
      border-radius: 6px;
      color: white;
      width: 130px;
      height: 40px;
      border: 1px solid ${({ theme }) => theme.talk_primary};
      :hover {
        border: 1px solid ${({ theme }) => theme.talk_primary};
        background: ${({ theme }) => theme.talk_primary};
        opacity: 0.8;
      }
    }

    .btn-cancel {
      border-radius: 6px;
      color: black;
      width: 130px;
      height: 40px;
      :hover {
        border: 1px solid ${({ theme }) => theme.talk_primary};
        color: black;
        opacity: 0.8;
      }
    }
  }
`
